import React from "react";
import get from "lodash/get";
import { useUpdateEffect } from "react-use";
import { useStoreActions, useStoreState } from "app/state/store/hooks";
import { CMSDataValueModel } from "app/state/api/action-reducers/sync";

interface UseCMSDataProps {
  loadData?: boolean;
  returnData?: boolean;
}

export function useCMSData(props: UseCMSDataProps) {
  const cmsData = useStoreState((state) => state.CMSData.value);
  const setCMSData = useStoreActions((actions) => actions.CMSData.setValue);

  const currentLanguage = "en";
  // COMPONENTS
  const componentsFooterCMSAction = useStoreActions(
    (actions) => actions.cms.componentsFooter.fetch
  );
  const componentsFooterCMSData = useStoreState(
    (state) => state.cms.componentsFooter.data
  );

  const componentsGenericBlockItemCMSAction = useStoreActions(
    (actions) => actions.cms.componentsGenericBlockItem.fetch
  );
  const componentsGenericBlockItemCMSData = useStoreState(
    (state) => state.cms.componentsGenericBlockItem.data
  );

  const componentsDetailPageNotFoundModalCMSAction = useStoreActions(
    (actions) => actions.cms.componentsDetailPageNotFoundModal.fetch
  );
  const componentsDetailPageNotFoundModalCMSData = useStoreState(
    (state) => state.cms.componentsDetailPageNotFoundModal.data
  );

  const componentsHeaderCMSAction = useStoreActions(
    (actions) => actions.cms.componentsHeader.fetch
  );
  const componentsHeaderCMSData = useStoreState(
    (state) => state.cms.componentsHeader.data
  );

  // PAGES

  const pagesLandingExplorerCMSAction = useStoreActions(
    (actions) => actions.cms.pagesLandingExplorer.fetch
  );
  const pagesLandingExplorerCMSData = useStoreState(
    (state) => state.cms.pagesLandingExplorer.data
  );

  const pagesExplorerActivityCMSAction = useStoreActions(
    (actions) => actions.cms.pagesExplorerActivity.fetch
  );
  const pagesExplorerActivityCMSData = useStoreState(
    (state) => state.cms.pagesExplorerActivity.data
  );

  const pagesExplorerLocationCMSAction = useStoreActions(
    (actions) => actions.cms.pagesExplorerLocation.fetch
  );
  const pagesExplorerLocationCMSData = useStoreState(
    (state) => state.cms.pagesExplorerLocation.data
  );

  const pagesExplorerOrganisationCMSAction = useStoreActions(
    (actions) => actions.cms.pagesExplorerOrganisation.fetch
  );
  const pagesExplorerOrganisationCMSData = useStoreState(
    (state) => state.cms.pagesExplorerOrganisation.data
  );

  const pagesExplorerSectorCMSAction = useStoreActions(
    (actions) => actions.cms.pagesExplorerSector.fetch
  );
  const pagesExplorerSectorCMSData = useStoreState(
    (state) => state.cms.pagesExplorerSector.data
  );
  const pagesLandingPublisherCMSAction = useStoreActions(
    (actions) => actions.cms.pagesLandingPublisher.fetch
  );
  const pagesLandingPublisherCMSData = useStoreState(
    (state) => state.cms.pagesLandingPublisher.data
  );
  const pagesExplorerCMSAction = useStoreActions(
    (actions) => actions.cms.pagesExplorer.fetch
  );
  const pagesExplorerCMSData = useStoreState(
    (state) => state.cms.pagesExplorer.data
  );
  const pagesExplorerLocationsCMSAction = useStoreActions(
    (actions) => actions.cms.pagesExplorerLocations.fetch
  );
  const pagesExplorerLocationsCMSData = useStoreState(
    (state) => state.cms.pagesExplorerLocations.data
  );
  const pagesExplorerOrganisationsCMSAction = useStoreActions(
    (actions) => actions.cms.pagesExplorerOrganisations.fetch
  );
  const pagesExplorerOrganisationsCMSData = useStoreState(
    (state) => state.cms.pagesExplorerOrganisations.data
  );
  const pagesExplorerSectorsCMSAction = useStoreActions(
    (actions) => actions.cms.pagesExplorerSectors.fetch
  );
  const pagesExplorerSectorsCMSData = useStoreState(
    (state) => state.cms.pagesExplorerSectors.data
  );
  const pagesExplorerActivitiesCMSAction = useStoreActions(
    (actions) => actions.cms.pagesExplorerActivities.fetch
  );
  const pagesExplorerActivitiesCMSData = useStoreState(
    (state) => state.cms.pagesExplorerActivities.data
  );
  const pagesExplorerFavouritesCMSAction = useStoreActions(
    (actions) => actions.cms.pagesExplorerFavourites.fetch
  );
  const pagesExplorerFavouritesCMSData = useStoreState(
    (state) => state.cms.pagesExplorerFavourites.data
  );
  const pagesPublisherCMSAction = useStoreActions(
    (actions) => actions.cms.pagesPublisher.fetch
  );
  const pagesPublisherCMSData = useStoreState(
    (state) => state.cms.pagesPublisher.data
  );
  const pagesPublisherPublishCMSAction = useStoreActions(
    (actions) => actions.cms.pagesPublisherPublish.fetch
  );
  const pagesPublisherPublishCMSData = useStoreState(
    (state) => state.cms.pagesPublisherPublish.data
  );
  const pagesDataHubCMSAction = useStoreActions(
    (actions) => actions.cms.pagesDataHub.fetch
  );
  const pagesDataHubCMSData = useStoreState(
    (state) => state.cms.pagesDataHub.data
  );
  const pagesLoginCMSAction = useStoreActions(
    (actions) => actions.cms.pagesLogin.fetch
  );
  const pagesLoginCMSData = useStoreState((state) => state.cms.pagesLogin.data);
  const pagesAccountProfileCMSAction = useStoreActions(
    (actions) => actions.cms.pagesAccountProfile.fetch
  );
  const pagesAccountProfileCMSData = useStoreState(
    (state) => state.cms.pagesAccountProfile.data
  );
  const pagesDataServicesCMSAction = useStoreActions(
    (actions) => actions.cms.pagesDataServices.fetch
  );
  const pagesDataServicesCMSData = useStoreState(
    (state) => state.cms.pagesDataServices.data
  );

  // GENERAL
  const ctaFooterCMSAction = useStoreActions(
    (actions) => actions.cms.ctaFooter.fetch
  );
  const ctaFooterCMSData = useStoreState((state) => state.cms.ctaFooter.data);

  const generalCMSAction = useStoreActions(
    (actions) => actions.cms.general.fetch
  );
  const generalCMSData = useStoreState((state) => state.cms.general.data);

  React.useEffect(() => {
    if (props.loadData) {
      // COMPONENTS

      componentsFooterCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      componentsHeaderCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      componentsDetailPageNotFoundModalCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      componentsGenericBlockItemCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      // PAGES

      pagesLandingExplorerCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      pagesLandingPublisherCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      pagesExplorerCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      pagesExplorerLocationsCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      pagesExplorerOrganisationsCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      pagesExplorerSectorsCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      pagesExplorerActivitiesCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      pagesExplorerFavouritesCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      pagesPublisherCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      pagesPublisherPublishCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      pagesDataHubCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      pagesLoginCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      pagesAccountProfileCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      pagesDataServicesCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      pagesExplorerActivityCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      pagesExplorerLocationCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      pagesExplorerOrganisationCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      pagesExplorerSectorCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });

      // GENERAL
      ctaFooterCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
      generalCMSAction({
        isCMSfetch: true,
        filterString: `locale=${currentLanguage}`,
      });
    }
  }, []);

  function formatCMSData() {
    let newData = {};
    const items = [
      // COMPONENTS
      {
        key: "componentsFooter",
        data: componentsFooterCMSData || null,
      },
      {
        key: "componentsHeader",
        data: componentsHeaderCMSData || null,
      },
      {
        key: "componentsDetailPageNotFoundModal",
        data: componentsDetailPageNotFoundModalCMSData || null,
      },
      {
        key: "componentsGenericBlockItem",
        data: componentsGenericBlockItemCMSData || null,
      },
      // PAGES
      {
        key: "pagesLandingExplorer",
        data: pagesLandingExplorerCMSData || null,
      },
      {
        key: "pagesLandingPublisher",
        data: pagesLandingPublisherCMSData || null,
      },
      {
        key: "pagesExplorer",
        data: pagesExplorerCMSData || null,
      },
      {
        key: "pagesExplorerActivity",
        data: pagesExplorerActivityCMSData || null,
      },
      {
        key: "pagesExplorerLocation",
        data: pagesExplorerLocationCMSData || null,
      },
      {
        key: "pagesExplorerOrganisation",
        data: pagesExplorerOrganisationCMSData || null,
      },
      {
        key: "pagesExplorerSector",
        data: pagesExplorerSectorCMSData || null,
      },
      {
        key: "pagesExplorerLocations",
        data: pagesExplorerLocationsCMSData || null,
      },
      {
        key: "pagesExplorerOrganisations",
        data: pagesExplorerOrganisationsCMSData || null,
      },
      {
        key: "pagesExplorerSectors",
        data: pagesExplorerSectorsCMSData || null,
      },
      {
        key: "pagesExplorerActivities",
        data: pagesExplorerActivitiesCMSData || null,
      },
      {
        key: "pagesExplorerFavourites",
        data: pagesExplorerFavouritesCMSData || null,
      },
      {
        key: "pagesPublisher",
        data: pagesPublisherCMSData || null,
      },
      {
        key: "pagesPublisherPublish",
        data: pagesPublisherPublishCMSData || null,
      },
      {
        key: "pagesDataHub",
        data: pagesDataHubCMSData || null,
      },
      {
        key: "pagesLogin",
        data: pagesLoginCMSData || null,
      },
      {
        key: "pagesAccountProfile",
        data: pagesAccountProfileCMSData || null,
      },
      {
        key: "pagesDataServices",
        data: pagesDataServicesCMSData || null,
      },
      // GENERAL
      {
        key: "ctaFooter",
        data: ctaFooterCMSData || null,
      },
      {
        key: "general",
        data: generalCMSData || null,
      },
    ];
    items.forEach((item) => {
      newData = {
        ...newData,
        [item.key]: get(item, "data.data"),
      };
    });
    setCMSData(newData as CMSDataValueModel);
  }

  useUpdateEffect(() => {
    if (props.loadData) {
      formatCMSData();
    }
  }, [
    // COMPONENTS
    componentsFooterCMSData,
    componentsHeaderCMSData,
    componentsDetailPageNotFoundModalCMSData,
    componentsGenericBlockItemCMSData,
    // PAGES
    pagesLandingExplorerCMSData,
    pagesLandingPublisherCMSData,
    pagesExplorerCMSData,
    pagesExplorerLocationsCMSData,
    pagesExplorerOrganisationsCMSData,
    pagesExplorerSectorsCMSData,
    pagesExplorerActivitiesCMSData,
    pagesExplorerFavouritesCMSData,
    pagesPublisherCMSData,
    pagesPublisherPublishCMSData,
    pagesDataHubCMSData,
    pagesLoginCMSData,
    pagesAccountProfileCMSData,
    pagesDataServicesCMSData,
    pagesExplorerActivityCMSData,
    pagesExplorerLocationCMSData,
    pagesExplorerOrganisationCMSData,
    pagesExplorerSectorCMSData,
    // GENERAL
    ctaFooterCMSData,
    generalCMSData,
  ]);

  if (props.returnData) {
    return cmsData;
  }

  return null;
}
